import { Link, useLocation } from "react-router-dom";
import { Calculator, Sparkles, User as UserIcon, Loader2 } from "lucide-react";
import { useAuth } from "@/lib/auth";

export const Header = () => {
  const loc = useLocation();
  const { user, loading } = useAuth();

  const linkCls = (path) =>
    `px-3 sm:px-4 py-2 rounded-full font-bold text-sm transition-all duration-150 ${
      loc.pathname === path
        ? "bg-[#0A0A0A] text-white"
        : "hover:bg-[#0A0A0A] hover:text-white"
    }`;

  return (
    <header className="no-print sticky top-0 z-30 bg-[#F9F9F6]/85 backdrop-blur-md border-b-[3px] border-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-4 flex items-center justify-between gap-3">
        <Link to="/" className="flex items-center gap-3 group" data-testid="header-logo-link">
          <div className="w-11 h-11 bg-brand-yellow border-[3px] border-[#0A0A0A] rounded-xl flex items-center justify-center shadow-brutal-sm group-hover:rotate-[-6deg] transition-transform">
            <Calculator strokeWidth={3} className="w-6 h-6 text-[#0A0A0A]" />
          </div>
          <span className="font-heading text-lg sm:text-2xl font-bold tracking-tight">
            iLove<span className="text-brand-coral">Math</span>Worksheets
          </span>
        </Link>
        <nav className="flex items-center gap-1 sm:gap-2">
          <Link to="/worksheet-from-photo" className={linkCls("/worksheet-from-photo")} data-testid="header-photo-link">
            <span className="hidden sm:inline">Prompt, text, photo or file to Worksheet</span>
            <span className="sm:hidden">Worksheet</span>
          </Link>
          {loading ? (
            <Loader2 className="w-4 h-4 animate-spin ml-2" />
          ) : user ? (
            <Link
              to="/account"
              className="ml-1 sm:ml-2 inline-flex items-center gap-2 px-3 py-1.5 rounded-full border-[3px] border-[#0A0A0A] bg-white shadow-brutal-xs hover:shadow-none hover:translate-y-[2px] transition"
              data-testid="header-account-link"
            >
              <div className="w-7 h-7 rounded-full bg-brand-yellow border-2 border-[#0A0A0A] flex items-center justify-center overflow-hidden">
                {user.picture ? (
                  <img src={user.picture} alt="" className="w-full h-full object-cover" />
                ) : (
                  <UserIcon strokeWidth={3} className="w-3.5 h-3.5" />
                )}
              </div>
              <span className="text-xs font-bold hidden sm:inline max-w-[100px] truncate">{user.name}</span>
            </Link>
          ) : (
            <>
              <Link to="/login" className={linkCls("/login")} data-testid="header-login-link">
                Log in
              </Link>
              <Link
                to="/register"
                className="hidden sm:inline-flex brutal-btn bg-brand-coral text-[#0A0A0A] px-4 py-2 text-sm items-center gap-2"
                data-testid="header-signup-cta"
              >
                <Sparkles strokeWidth={2.5} className="w-4 h-4" />
                Sign up free
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;
